import React from 'react';
import '../styles/Leadership.css';

const Leadership = () => {
  const teamMembers = [
    {
      name: 'Rajesh Agarwal',
      position: 'Director',
      linkedin: 'https://www.linkedin.com/in/'
    },
    {
      name: 'Shrinivas Bhat',
      position: 'Director',
      linkedin: 'https://www.linkedin.com/in/'
    },
    // {
    //   name: 'Girish Subramanyam',
    //   position: 'VP Sales',
    //   linkedin: 'https://www.linkedin.com/in/'
    // },
    // {
    //   name: 'Amit Kumar',
    //   position: 'Country Manager - Aerospace & Defence',
    //   linkedin: 'https://www.linkedin.com/in/'
    // },
    // {
    //   name: 'Jathin KP',
    //   position: 'Director - Business Development Academia',
    //   linkedin: 'https://www.linkedin.com/in/'
    // },
    // {
    //   name: 'Kush Parikh',
    //   position: 'RF Technology Head',
    //   linkedin: 'https://www.linkedin.com/in/'
    // },
    // {
    //   name: 'Siddartha K S',
    //   position: 'Finance Head',
    //   linkedin: 'https://www.linkedin.com/in/'
    // },
    // {
    //   name: 'Sanket Jahagirdar',
    //   position: 'Regional Sales Manager',
    //   linkedin: 'https://www.linkedin.com/in/'
    // },
  ];

  return (
    <section className="leadership-section">
      <div className="leadership-container">
        <div className="leadership-header">
          <h2 className="leadership-title">Our Leadership Team</h2>
          <div className="title-underline"></div>
        </div>
        
        <div className="leadership-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="leader-card">
              <div className="leader-avatar">
                {member.name.split(' ')[0][0]}{member.name.split(' ').slice(-1)[0][0]}
              </div>
              <div className="leader-info">
                <h3 className="leader-name">{member.name}</h3>
                <p className="leader-position">{member.position}</p>
                {/* <button 
                  className="linkedin-button"
                  onClick={() => handleLinkedInClick(member.linkedin)}
                  aria-label={`Visit ${member.name}'s LinkedIn profile`}
                >
                  <svg className="linkedin-icon" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                  </svg>
                  <span>Connect on LinkedIn</span>
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leadership;